// extracted by mini-css-extract-plugin
var _1 = "AnnotationInput-module__animateUploadProgressBarWidth--r4lsd";
var _2 = "AnnotationInput-module__animatedBackground--rgAy_";
var _3 = "AnnotationInput-module__container--AsMHI";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container" }
